const MIN_RENT_PRICE = 30000;
const MIN_BUY_PRICE = 5000000;
const EUR_RATE = 4.6;

const form = document.querySelector(".js-exclusive .form");
const alertNode = document.querySelector(".js-exclusive-alert");
const alertCloseNode = document.querySelector(".js-exclusive-alert-close");

if (form && alertNode) {
    const buy = document.querySelector(".js-buy");
    const rent = document.querySelector(".js-rent");
    const priceFrom = document.querySelector(".js-price-from");

    form.addEventListener("submit", (e) => {
        const currency = localStorage.getItem('gk_currency');
        const currencyRate = currency === "EUR" ? EUR_RATE : 1;
        let showAlert = false;
        let redirectUrl = "";

        if (rent.checked && priceFrom.value != "") {
            if (priceFrom.value < (MIN_RENT_PRICE / currencyRate)) {
                showAlert = true;
                redirectUrl = rent.dataset.redirect
            }
        } else if (buy.checked && priceFrom.value != "") {
            if (priceFrom.value < (MIN_BUY_PRICE / currencyRate)) {
                showAlert = true;
                redirectUrl = buy.dataset.redirect;
            }
        }

        if (showAlert) {
            e.preventDefault();
            if (alertNode.classList.contains("show")) {
                window.location.href = redirectUrl;
            } else {
                alertNode.classList.add("show");
            }
        }
    });
}

if (alertCloseNode && alertNode) {
    alertCloseNode.addEventListener("click", () => {
        alertNode.classList.remove("show");
    });
}
